module.exports = __webpack_public_path__ + "media/dashboard/assets/images/arrow-up-short-4a7bc94293ee5bca44348e03eeba6f8a.svg";